import { createAsyncThunk } from '@reduxjs/toolkit';

const getOpenJobs = async (_payload, { extra: { http } }) => {
  try {
    const result = await http.get(`/ats_jobs?only=open`);
    return result;
  } catch (e) {}
};

export const fetchOpenJobs = createAsyncThunk('jobs/fetch/all', getOpenJobs);
